import { Trans, useTranslation } from 'next-i18next'
import capitalize from 'lodash/capitalize'

import {
  Heading2,
  LinkGrid,
  LinkText,
  Section2
} from '@/features/Listings/seo/elements'
import useFilterSlug from '@/features/Listings/seo/search-results-content/content/use-filter-slug'
import { toTitleCase } from '@/features/Listings/seo/search-results-content/content/utils'
import { HoodData } from '@/features/Listings/seo/types'
import { Label } from '@/components/text'

const NearbyPois = ({
  filterSlug,
  poiName,
  nearby
}: {
  cityNameWithState: string
  filterSlug: string
  poiName: string
  nearby: HoodData[]
}) => {
  const { t } = useTranslation()
  const { hasFilter, filterName } = useFilterSlug(filterSlug)

  const filterNameWithFallback = hasFilter
    ? toTitleCase(filterName)
    : t('seo.pois:Apartments, Houses & Rooms for Rent')

  const linkFilterNameWithFallback = hasFilter
    ? filterName
    : t('seo.pois:apartments for rent')

  return (
    <Section2>
      <Heading2>
        <Trans
          i18nKey="seo.pois:Nearby POIs w Filter LOCATION"
          values={{
            filterName: filterNameWithFallback,
            location: poiName
          }}
          defaults="Other {{ filterName }} Near {{ location }}"
        />
      </Heading2>
      <LinkGrid linksOnly>
        {nearby.map(poi => {
          const link = `/rental-listings/city/${poi.slug.slug_city}/${
            poi.slug.slug_name
          }${filterSlug ? `/${filterSlug}` : ''}`
          return (
            <Label key={link} fontSize="14px">
              <LinkText href={link}>
                <Trans
                  i18nKey="seo.pois:nearby poi apartments for rent"
                  values={{
                    filterName: capitalize(linkFilterNameWithFallback),
                    city: poi.city,
                    state: poi.state,
                    poiName: poi.name
                  }}
                  defaults="{{ filterName }} in {{ city }}, {{ state }} near {{ poiName }}"
                />
              </LinkText>
            </Label>
          )
        })}
      </LinkGrid>
    </Section2>
  )
}

export default NearbyPois
